const IOS_REGEXP = /iPhone|iPad|iPod/i;

export const isIOS = (): boolean => IOS_REGEXP.test(navigator.userAgent);
